// assets/js/brands-slider.js
import gsap from 'gsap';

export async function initBrandSlider(selector='[data-gsap-marquee]'){
  // plus de check window.gsap ; gsap vient de l'import
  const decodeAll = (imgs) => Promise.all(
    imgs.map(img => (img.decode ? img.decode().catch(()=>{}) : new Promise(res=>{
      if (img.complete) return res();
      img.addEventListener('load', res, { once:true });
      img.addEventListener('error', res, { once:true });
    })))
  );

  document.querySelectorAll(selector).forEach(async (viewport, idx) => {
    const track = viewport.querySelector('.brand-slider__track');
    if (!track) return;

    const slides = Array.from(track.children);
    const half   = Math.floor(slides.length / 2);
    const imgs   = Array.from(track.querySelectorAll('img'));

    console.info('[BrandSlider] init on node#'+idx, {slides:slides.length, imgs:imgs.length});
    await decodeAll(imgs);

    const measureWidth = () => {
      let w = 0;
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.gap || '0') || 0;
      for (let i=0;i<half;i++){
        w += slides[i].getBoundingClientRect().width + gap;
      }
      return w;
    };

    const section = viewport.closest('section');
    const speedVar = section ? getComputedStyle(section).getPropertyValue('--bs-speed') : '';
    const speed = parseFloat(speedVar) || 60;

    let baseWidth = measureWidth();
    console.info('[BrandSlider] baseWidth=', baseWidth, 'speed=', speed);
    if (baseWidth <= 0){ console.warn('[BrandSlider] largeur = 0'); return; }

    const tween = gsap.fromTo(track, { x: 0 }, {
      x: -baseWidth,
      duration: baseWidth / speed,
      ease: 'none',
      repeat: -1,
      modifiers: { x: gsap.utils.unitize(v => (parseFloat(v) % -baseWidth)) }
    });

    viewport.addEventListener('mouseenter', () => tween.pause());
    viewport.addEventListener('mouseleave', () => tween.play());
    viewport.addEventListener('focusin',   () => tween.pause());
    viewport.addEventListener('focusout',  () => tween.play());

    let rAF;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        tween.pause(0);
        baseWidth = measureWidth();
        console.info('[BrandSlider] resize baseWidth=', baseWidth);
        if (baseWidth > 0){
          tween.vars.x = -baseWidth;
          tween.vars.duration = baseWidth / speed;
          tween.invalidate().restart();
        }
      });
    });
  });
}
